export const PLAYERS_ENDPOINTS = {
  GET_ALL: '/players',
  CREATE: '/players',
  UPDATE: (id) => `/players/${id}`,
  DELETE: (id) => `/players/${id}`,
  GET_BY_ID: (id) => `/players/${id}`
};
